module.exports = __webpack_public_path__ + "static/media/frc-halloween-image-2.f5f2dfe3.png";